import clsx from 'clsx'
import GridSpinner from 'components/UI/GridSpinner'
import { Button, Container, Icon, List, Spinner } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from 'modules/Referral/PayoutProfiles/List/subcomponents/List/payout-profiles-list.module.scss'
import { useTableConfig } from 'modules/Referral/PayoutProfiles/List/subcomponents/List/hooks/useTableConfig'

const ListComponent = ({ data = [], pagination, loading, onChangePage, EmptyComponent = null }) => {
  const { t } = useTranslation()
  const { tableState, tableConfig } = useTableConfig({}, data)

  return (
    <>
      {data.length === 0 && loading ? (
        <GridSpinner />
      ) : (
        <List
          table={tableState}
          config={tableConfig}
          EmptyComponent={EmptyComponent}
        />
      )}

      {data.length > 0 && pagination.total !== data.length && (
        <div className={styles['pagination']}>
          <Container
            display={'flex'}
            flexAlign={'center'}
            flexJustify={'center'}
            className={styles['show-more__container']}
          >
            {pagination.total !== data.length && (
              <Button
                onClick={() => onChangePage(1)}
                className={clsx(styles['show-more__button'])}
                variant={'link'}
                color={'Label-GU-Primary'}
                startIcon={
                  loading ? (
                    <Spinner
                      width={16}
                      color={'inherit'}
                    />
                  ) : null
                }
                endIcon={
                  <Icon
                    name={'arrow-down'}
                    color={'inherit'}
                    size={'s'}
                  />
                }
              >
                {t('common::pagination.show_more')}
              </Button>
            )}
          </Container>
        </div>
      )}
    </>
  )
}

ListComponent.propTypes = {
  data: PropTypes.array,
  pagination: PropTypes.object,
  loading: PropTypes.bool,
  onChangePage: PropTypes.func,
  EmptyComponent: PropTypes.elementType,
}

export default ListComponent
